// Auto-generated by `yarn translations:generate-namespace` — do not edit manually
import React from 'react';
import i18next, {} from 'i18next';
/**
 * Returns the namespace-scoped `t` function for "login-screen".
 *
 * The `_loadState` argument is intentionally unused: React Compiler memoizes a
 * consumer's `t($ => ...)` lookups on the identity of `t`, and `i18next.getFixedT`
 * returns a function whose identity never changes even though the strings it
 * resolves only become available once the namespace has loaded. Because this is a
 * module-scope function, the compiler treats the call as opaque and keys it on the
 * `_loadState` argument — yielding a fresh `t` identity when `ready` flips, which is
 * what makes memoized consumers re-resolve their keys once the namespace is ready.
 * Without it, components that render before the namespace loads would show the raw
 * translation keys for the rest of their lifetime.
 */
const createNamespacedT = (namespace, _loadState) => {
    // eslint-disable-next-line no-restricted-properties
    return i18next.getFixedT(null, namespace);
};
/**
 * Lazily loads the "login-screen" translation namespace and returns a typed `t` function
 * that uses the selector syntax: `t($ => $.myKey)`.
 *
 * @returns An object with:
 *  - `t`: a namespace-scoped, typed translation function (available once loaded)
 *  - `ready`: whether the namespace has finished loading
 */
export const useLoginScreenTranslationsJson = () => {
    const [ready, setReady] = React.useState(i18next.hasLoadedNamespace('login-screen'));
    React.useEffect(() => {
        if (!ready) {
            i18next.loadNamespaces('login-screen').then(() => setReady(true));
        }
    }, [ready]);
    return React.useMemo(() => ({
        t: createNamespacedT('login-screen', ready),
        ready,
    }), [ready]);
};
